import { levelEnum } from "@/utilities/enum";

const {
  ADMIN,
  KONTRAKTOR,
  REPORTER,
  ENVIRONMENT,
  OHS,
  ISAFE,
  IMPROVEMENT,
  EXTERNAL,
} = levelEnum;

/**
 * Resolve role user ke levelEnum (sama dengan SidebarLayout & roleMixin).
 * @param {object|null} user
 * @returns {string|null}
 */
export function resolveUserRoleFromSession(user) {
  if (!user?.role) return null;

  const roles = user.role;
  if (Array.isArray(roles)) {
    if (roles.includes("ADMIN")) return ADMIN;
    if (roles.includes("OHS")) return OHS;
    if (roles.includes("REPORTER")) return REPORTER;
    if (roles.includes("ENVIRONMENT")) return ENVIRONMENT;
    if (roles.includes("IMPROVEMENT")) return IMPROVEMENT;
    return ISAFE;
  }

  if (roles === KONTRAKTOR) return KONTRAKTOR;
  if (roles === EXTERNAL) return EXTERNAL;

  return ISAFE;
}

/**
 * Cek apakah role user boleh mengakses route.
 * @param {string|null} userRole
 * @param {string[]|undefined} allowedRoles
 */
export function canAccessRoute(userRole, allowedRoles) {
  if (!allowedRoles?.length) return true;
  if (!userRole) return false;
  return allowedRoles.includes(userRole);
}

/**
 * Default redirect saat user tidak punya akses.
 * @param {string|null} userRole
 */
export function getDefaultRouteForRole(userRole) {
  if (userRole === IMPROVEMENT) return "/dashboard-esg";
  if (userRole === EXTERNAL) return "/nc-audit-iso-smk3-external-monitoring";
  return "/dashboard";
}
